import './Services.css';
import {BsCheck} from 'react-icons/bs'
const Services=()=>{
    return(
        <>
            <section id='services'>
                <h5>What I Offer</h5>
                <h2>Services</h2>
                <div className='container services_container'>
                    <div className='services_container1'>
                        <div className='services_container11'><h3>UI/UX Design</h3></div>
                        <div className='services_container12'>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                    </div>
                    </div>
                    <div className='services_container2'>
                        <div className='services_container11'><h3>Web Development</h3></div>
                        <div className='services_container12'>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        </div>
                    </div>
                    <div className='services_container1'>
                        <div className='services_container11'><h3>Content Creation</h3></div>
                        <div className='services_container12'>
                        <div className='services_container121'>

                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        <div className='services_container121'>
                        <div className='services_img'><BsCheck></BsCheck></div>
                        <p>Lorem ipsum dolor sit amet, consectetur</p>
                        </div>
                        </div>
                    </div>
                    <div>
                        
                    </div>
                    <div>
                        
                    </div>
                </div>
            </section>
        </>
        );
}
export default Services;